import React from "react";
import { Text } from "../../deprecated/Text/Text";
import styles from "./SectionSplitterLabel.module.css";

interface SectionSplitterLabelProps {
  text?: string;
  className?: string;

  marginTop?: number;
  marginBottom?: number;
}

export const SectionSplitterLabel = (props: SectionSplitterLabelProps) => {
  const cssProperties: React.CSSProperties = {};
  if (props.marginTop) cssProperties.marginTop = props.marginTop;
  if (props.marginBottom) cssProperties.marginBottom = props.marginBottom;

  return (
    <div style={cssProperties}>
      {props.text ? (
        <Text className={styles.text + " " + (props.className ?? "")} size="md" color="accent" display="">
          {props.text}
        </Text>
      ) : (
        <div className={styles.sectionSplitter} />
      )}
    </div>
  );
};

